import { ClipLoader } from "react-spinners";

const SellerLoader = () => {
    return (
        <div className="absolute inset-0 flex  justify-center  bg-opacity-50 bg-gray-500 z-50">
            <div className="flex items-center justify-center w-24 h-24 mt-[20%] bg-gray-100 rounded-full">
                <ClipLoader size={40} color="#3498db" />
            </div>
        </div>
    );
};

export default SellerLoader;
